import { Form, FormField, FormFieldConditions, FormSection, FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { RecogidaModel } from 'src/app/models/recogida.model';


export class RecogidasListModalFormDefinition {
  public readonly formFields: Form<RecogidaModel>;
  public readonly model: Partial<RecogidaModel>;

  constructor(type: FormType, model: Partial<RecogidaModel>, private readonly context: any = {}) {
    this.model = model;
    this.formFields = {
      name: 'recogidas-list-modal',
      header: 'Datos de la recogida',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<RecogidaModel>[] {
    return [
      {
        name: '',
        fields: [
          this.textField('finca', this.context.fincaName ?? 'Finca', 1, true, 4),
          this.textField('fecha', 'Fecha de Recogida', 2, true, 4),
          this.textField('sector', 'Sector', 3, true, 4),
          this.textField('parcelas', this.context.parcelasName ?? 'Parcelas', 4, true, 4, InputType.TEXTAREA),
          this.textField('albaran', 'Nº Albarán', 5, true, 4),
          this.textField('cultivo', 'Cultivo', 6, true, 4),
          this.textField('variedad', 'Variedad', 7, true, 4),
          this.textField('cantidad', 'Cantidad Kg', 8, true, 4),
        ],
        width: 12,
        isVisible: true,
        order: 1,
      },
    ];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<RecogidaModel> {
    return {
      name,
      vinculatedFields: undefined,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
